import React, { useState, useEffect, useRef } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import Sidebar from "../Components/Sidebar/Sidebar";
import Form from "react-bootstrap/Form";
import { Roller } from "react-awesome-spinners";
import { getOlderBookingList, getOlderDownloadBookingList } from "../Api/bookingApi";
import { CSVLink } from "react-csv";
import { Spinner } from "react-bootstrap";

const BookingSourceReport = () => {
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  // const [limit, setLimit] = useState("all");
  const [startDate, setStartDate] = useState(() => {
    const date = new Date();
    const first = new Date(date.getFullYear(), date.getMonth(), 1);
    return first.toISOString().split("T")[0]; // YYYY-MM-DD
  });

  const [endDate, setEndDate] = useState(() => {
    const date = new Date();
    const last = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return last.toISOString().split("T")[0]; // YYYY-MM-DD
  });
  const [bookBy, setBookBy] = useState("all");
  const date = new Date();
  const first = new Date(date.getFullYear(), date.getMonth(), 1);
  const last = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  const start = first.toISOString().split("T")[0];
  const end = last.toISOString().split("T")[0];
  const [tableConfig, setTableConfig] = React.useState({
    page: 1,
    sizePerPage: 10,
    filters: {},
    sortField: "",
    sortOrder: "",
    bookingStage: statusFilter,
    clientStage: "",
  });
  const preventApiTrigger = useRef(false);
  const [pageOption, setPageOption] = React.useState({
    totalSize: 0,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  });
  const [bookingData, setBookingData] = useState([]);
  const [debouncedText, setDebouncedText] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedText(searchText);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchText]);

  const handleChange = (e) => {
    setSearchText(e.target.value);
  };

const bookByFormatter = (cell, row) => {
    let booking_by = "";
    switch (row.book_by) {
      case "0":
        booking_by = "Admin";
        break;
      case "1":
        booking_by = "User";
        break;
      case "2":
        booking_by = "Technician";
        break;
    }
    return <span>{booking_by}</span>;
  };

  const statusFormatter = (cell, row) => {
    let badgeClass = "";
    let booking_status = "";
    switch (row.booking_status) {
      case "A":
      case "AC":
        booking_status = "Unconfirmed Booking";
        badgeClass = "badge bg-active text-dark";
        break;
      case "CS":
        booking_status = "Cancel by service provider";
        badgeClass = "badge bg-cancel-service-provider text-wrapped";
        break;
      case "CO":
        booking_status = "Completed";
        badgeClass = "badge bg-completed";
        break;
      case "UC":
        booking_status = "Confirmed by Client";
        badgeClass = "badge bg-confirm-client";
        break;
      case "FSR":
      case "C":
        booking_status = "Confirmed by FSR";
        badgeClass = "badge bg-FSR text-dark";
        break;
      default:
        badgeClass = "badge bg-secondary";
    }

    return <span className={badgeClass}>{booking_status}</span>;
  };

  const columns = [
    {
      dataField: "id",
      text: "ID",
      sort: false,
      visible: true,
      formatter: (cell, row, index) => index + 1,
    },
    {
      dataField: "booking_date_time",
      text: "DATE",
      sort: true,
      visible: true,
    },
    {
      dataField: "first_name",
      text: "NAME",
      sort: false,
      visible: true,
      formatter: (cell, row) => row.first_name + " " + row.last_name,
    },
    {
      dataField: "user_email",
      text: " EMAIL",
      sort: false,
      visible: true,
      formatter: (cell, row) => row.user_email,
    },
    {
      dataField: "phone",
      text: "PHONE",
      sort: false,
      visible: true,
      formatter: (cell, row) => row.phone,
    },
    {
      dataField: "booking_status",
      text: "BOOKING STATUS",
      sort: true,
      formatter: statusFormatter,
      visible: true,
    },
    {
      dataField: "customer_stage",
      text: "CLIENT STAGE",
      sort: true,
      visible: true,
    },
     {
      dataField: "book_by",
      text: "BOOKED BY",
      sort: false,
      visible: true,
      formatter: bookByFormatter,
    },
    {
      dataField: "given_name",
      text: "FSR",
      sort: true,
      visible: true,
      formatter: (cell, row) => row.given_name || "-",
    },
    {
      dataField: "app_notes",
      text: "Note",
      sort: false,
      visible: true,
    },
    {
      dataField: "reject_reason",
      text: "REJECT REASON",
      sort: false,
      visible: true,
    }
  ];
  const visibleColumns = columns.filter((col) => col.visible);

  const pagination = paginationFactory({
    ...pageOption,
    page: tableConfig.page,
    sizePerPage: tableConfig.sizePerPage,
    lastPageText: ">>",
    firstPageText: "<<",
    nextPageText: ">",
    prePageText: "<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: function (page, sizePerPage) {
      // console.log("page", page);
      // console.log("sizePerPage", sizePerPage);
    },
    onSizePerPageChange: function (page, sizePerPage) {
      // console.log("page", page);
      // console.log("sizePerPage", sizePerPage);
    },
  });

  const clearFilters = () => {
    setSearchText("");
    setStatusFilter("all");
    // setLimit("all");
    setStartDate(start);
    setEndDate(end);
    setBookBy("all");
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder }
  ) => {
    if (preventApiTrigger.current) {
      preventApiTrigger.current = false;
      return;
    }

    const newPage = type === "filter" ? 1 : page;

    let newSortOrder = sortOrder;
    if (sortField === tableConfig.sortField) {
      newSortOrder = tableConfig.sortOrder === "asc" ? "desc" : "asc";
    } else {
      newSortOrder = "asc";
    }

    let safeSortField = sortField ?? "";
    let safeSortOrder = newSortOrder ?? "";

    if (safeSortField === "") {
      safeSortField = "";
    }

    if (safeSortOrder === "") {
      safeSortOrder = "";
    }

    if (statusFilter === "") {
      setStatusFilter("all");
    }
    const updatedConfig = {
      ...tableConfig,
      page: newPage,
      sizePerPage,
      sortField: safeSortField,
      sortOrder: safeSortOrder,
    };
    try {
      setTableConfig(updatedConfig);
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }

    getBookingData(
      newPage,
      sizePerPage,
      updatedConfig.filters,
      safeSortField,
      safeSortOrder,
      debouncedText,
      updatedConfig.bookingStage,
      updatedConfig.clientStage,
      startDate,
      endDate
    );
  };

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  const getBookingData = async (
    page,
    sizePerPage,
    filters,
    sortField,
    sortOrder,
    bookingStage = "",
    clientStage = ""
  ) => {
    try {
      setLoading(true);
      const formData = new URLSearchParams();
      // formData.append("limit", limit);
      formData.append("start_date", startDate ? startDate : "2025-10-01");
      formData.append("end_date", endDate ? endDate : "2025-12-30");
      formData.append("book_by", bookBy);
      formData.append("page", page || 1);
      formData.append("page_size", sizePerPage || 10);
      formData.append("filters", JSON.stringify(filters) || "");

      formData.append("order_by", sortField || "");
      formData.append("order_type", sortOrder || "");
      formData.append("searchText", debouncedText || "");
      formData.append("bookingStage", statusFilter || "");
      formData.append("clientStage", clientStage || "all");

      getOlderBookingList(formData).then((res) => {
        if (res.code === 200) {
          setLoading(false);
          const apiResponse = res.data;
          setBookingData(apiResponse.data.bookings);
          setPageOption({
            totalSize: apiResponse.data.total_rows,
            hideSizePerPage: false,
            hidePageListOnlyOnePage: true,
          });
        }
      });
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // if (verifyPassword) {
      getBookingData(
        tableConfig.page,
        tableConfig.sizePerPage,
        tableConfig.filters,
        tableConfig.sortField,
        tableConfig.sortOrder,
        debouncedText,
        tableConfig.bookingStage,
        tableConfig?.clientStage
      );
    // }
  }, [
    tableConfig,
    startDate,
    endDate,
    bookBy,
    debouncedText,
    statusFilter,
    // verifyPassword,
  ]);

  const [csvReportData, setCsvReportData] = useState([]);
  const [csvLoader, setCsvLoader] = useState(false);
  const csvLinkRef = useRef();

  const getAllData = async () => {
    setCsvLoader(true);
    const formData = new URLSearchParams();
    // formData.append("limit", limit);
    formData.append("start_date", startDate ? startDate : "2025-10-01");
    formData.append("end_date", endDate ? endDate : "2025-12-30");
    formData.append("book_by", bookBy);
    formData.append("page", tableConfig.page || 1);
    formData.append("page_size", tableConfig.sizePerPage || 10);
    formData.append("filters", JSON.stringify(tableConfig.filters) || "");

    formData.append("order_by", tableConfig.sortField || "");
    formData.append("order_type", tableConfig.sortOrder || "");
    formData.append("searchText", debouncedText || "");
    formData.append("bookingStage", statusFilter || "");
    formData.append("clientStage", "all");
    try {
      const res = await getOlderDownloadBookingList(formData);
      if (res.code === 200) {
        const apiResponse = res.data;
        setCsvReportData(apiResponse.data.bookings);

        setTimeout(() => {
          csvLinkRef.current.link.click();
        }, 200);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setCsvLoader(false);
    }
  };

  const csvReport = {
    data: csvReportData.map((item) => ({
      name: (item.first_name || "").trim(),
      email: (item.user_email || "").trim(),
      phone: (item.phone || "").trim(),
      customer_stage: (item.customer_stage || "").trim(),
      book_by: (item.book_by == '0' ? 'Admin' : (item.book_by == '1' ? 'User' : "Technician")).trim(),
      // booking_status: (item.booking_status || "").trim(),
      booking_date_time: (item.booking_date_time || "").trim(),
      app_notes: (item.app_notes || "").trim(),
      reject_reason: (item.reject_reason || "").trim(),
    })),
    headers: [
      { label: "NAME", key: "name" },
      { label: "EMAIL", key: "email" },
      { label: "PHONE", key: "phone" },
      { label: "CUSTOMER STAGE", key: "customer_stage" },
      { label: "BOOKED BY", key: "book_by" },
      // { label: "BOOKING STATUS", key: "booking_status" },
      { label: "BOOKING DATE", key: "booking_date_time" },
      { label: "Note", key: "app_notes" },
      { label: "REJECT REASON", key: "reject_reason" },
    ],
    filename: "BookingSourceReport.csv",
  };

  // Main booking report screen
  return (
    <div>
      {loading ? (
        <div className="loading">
          <Roller size={50} color="#75b317" />
        </div>
      ) : (
        <div className="dashboard-container d-flex">
          <div className="sidebar-container">
            <Sidebar />
          </div>
          <div className="main-container">
            <div className="main-page-body-content">
              <div className="main-page-body-content-body">
                <div className="main-page-body-content-body-container">
                  <div className="container-fulid">
                    <div className="table-card">
                      <div className="card-body table-card-body">
                        <div className="table-card-header mb-4 d-flex justify-content-between">
                          <h5 className="card-title">Booking Source Report</h5>
                        </div>
                        <div className="table-card-body-inner">
                          <div className="animated fadeIn">
                            <div className="row">
                              <div className="col-md-12">
                                  <div className="card">
                                    <div className="card-header table-card-header">
                                      <div className="row g-4 align-items-center">
                                        {/* <div className="col-md-3">
                                          <Form.Group>
                                            <Form.Label className="mb-2 fw-semibold">
                                              Search
                                            </Form.Label>
                                            <Form.Control
                                              type="text"
                                              placeholder="Search by name, email, staff..."
                                              onChange={handleChange}
                                            />
                                          </Form.Group>
                                        </div>

                                        <div className="col-md-2">
                                          <Form.Group>
                                            <Form.Label className="mb-2 fw-semibold">
                                              Client Status
                                            </Form.Label>
                                            <Form.Select
                                              value={statusFilter}
                                              onChange={(e) =>
                                                setStatusFilter(e.target.value)
                                              }
                                            >
                                              <option value="all">
                                                All Status
                                              </option>
                                              <option value="A">Active</option>
                                              <option value="C">Confirm</option>
                                              <option value="CS">
                                                Cancelled by Service Provider
                                              </option>
                                              <option value="CO">
                                                Completed
                                              </option>
                                              <option value="UC">
                                                Confirmed by Client
                                              </option>
                                              <option value="FSR">Confirmed by FSR</option>
                                            </Form.Select>
                                          </Form.Group>
                                        </div> */}

                                        <div className="col-md-2">
                                          <Form.Group>
                                            <Form.Label className="mb-2 fw-semibold">
                                              Book By
                                            </Form.Label>
                                            <Form.Select
                                              value={bookBy}
                                              onChange={(e) => {
                                                setBookBy(e.target.value);
                                                setTableConfig((prev) => ({
                                                  ...prev,
                                                  page: 1,
                                                }));
                                              }}
                                            >
                                              <option value="all">All Book By</option>
                                              <option value="0">Admin</option>
                                              <option value="1">User</option>
                                              <option value="2">Technician</option>
                                            </Form.Select>
                                          </Form.Group>
                                        </div>

                                        {/* <div className="col-md-2">
                                          <Form.Group>
                                            <Form.Label className="mb-2 fw-semibold">
                                              Older than
                                            </Form.Label>
                                            <Form.Select
                                              value={limit}
                                              onChange={(e) => {
                                                setLimit(e.target.value);
                                                setTableConfig((prev) => ({
                                                  ...prev,
                                                  page: 1,
                                                }));
                                              }}
                                            >
                                              <option value='all'>All</option>
                                              <option value={1}>1 Month</option>
                                              <option value={2}>2 Month</option>
                                              <option value={3}>3 Month</option>
                                              <option value={4}>4 Month</option>
                                              <option value={5}>5 Month</option>
                                              <option value={6}>6 Month</option>
                                              <option value={7}>7 Month</option>
                                              <option value={8}>8 Month</option>
                                              <option value={9}>9 Month</option>
                                              <option value={10}>10 Month</option>
                                              <option value={11}>11 Month</option>
                                              <option value={12}>12 Month</option>
                                            </Form.Select>
                                          </Form.Group>
                                        </div> */}

                                        <div className="col-md-2">
                                          <Form.Group>
                                            <Form.Label className="mb-2 fw-semibold">
                                              Start Date
                                            </Form.Label>
                                            <Form.Control
                                              type="date"
                                              value={startDate}
                                              onChange={(e) => {
                                                setStartDate(e.target.value);
                                                setTableConfig((prev) => ({
                                                  ...prev,
                                                  page: 1,
                                                }));
                                              }}
                                              placeholder="Select start date"
                                            />
                                          </Form.Group>
                                        </div>

                                        <div className="col-md-2">
                                          <Form.Group>
                                            <Form.Label className="mb-2 fw-semibold">
                                              End Date
                                            </Form.Label>
                                            <Form.Control
                                              type="date"
                                              value={endDate}
                                              onChange={(e) => {
                                                setEndDate(e.target.value);
                                                setTableConfig((prev) => ({
                                                  ...prev,
                                                  page: 1,
                                                }));
                                              }}
                                              min={startDate}
                                              placeholder="Select end date"
                                            />
                                          </Form.Group>
                                        </div>
                                        <div className="col-md-2 d-flex align-items-end mt-5">
                                          <button
                                            className="btn btn-primary downloads-btn-preview w-100"
                                            onClick={() => getAllData()}
                                          >
                                            {csvLoader ? (
                                              <Spinner
                                                animation="border"
                                                role="status"
                                                size="sm"
                                                className="me-1 "
                                              />
                                            ) : (
                                              "Export CSV"
                                            )}
                                          </button>

                                          <CSVLink
                                            {...csvReport}
                                            ref={csvLinkRef}
                                            style={{ display: "none" }}
                                          />
                                        </div>
                                        <div className="col-md-2 d-flex align-items-end mt-5">
                                          <button
                                            className="btn btn-secondary w-100"
                                            onClick={clearFilters}
                                          >
                                            Clear
                                          </button>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="card-body">
                                      {bookingData && bookingData.length > 0 ? (
                                        <>
                                          <BootstrapTable
                                            bootstrap4
                                            keyField="id"
                                            data={bookingData}
                                            remote={{
                                              pagination: true,
                                              sort: true,
                                            }}
                                            onTableChange={handleTableChange}
                                            columns={visibleColumns}
                                            pagination={pagination}
                                          />
                                        </>
                                      ) : (
                                        <div className="text-center py-5">
                                          <h5 className="text-muted">
                                            No Data Found
                                          </h5>
                                          <p className="text-muted">
                                            There are no booking records
                                            available matching your filters.
                                          </p>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingSourceReport;